<template>
  <div class="markers">
    <transition-group name="fade">
      <gmap-custom-marker
        :marker="location._geoloc"
        :ref="`location-${location.id}`"
        class="markers__marker"
        v-for="(location, idx) in locations"
        :key="`location-${idx}`"
        :zIndex="
          currentLocation === location || ($route.name === 'location' && location.brand_status)
            ? 52
            : location.first
            ? 51
            : 50
        "
        @click.native="toggleElements(location)"
      >
        <div
          class="markers__marker__content"
          :class="{
            'markers__marker__content--hightlight':
              currentLocation === location ||
              settings.marker.score === true ||
              ($route.name === 'location' && location.internal_id === $route.params.location),
            'markers__marker__content--tiny': settings.marker.tiny === true,
          }"
          v-if="currentValue(location, source) !== -1 && isVisible(location)"
        >
          <img
            :src="require('@/assets/img/svg/crown.svg')"
            class="markers__marker__content__koth"
            :class="{ 'markers__marker__content__koth--translate': settings.marker.acronym === true }"
            v-if="location.first"
          />
          <marker-acronym
            class="markers__marker__content__acronym"
            :acronym="location.acronym"
            v-if="settings.marker.acronym === true"
          />
          <div
            class="markers__marker__content__score"
            :class="{
              'markers__marker__content__score--md': scientificNumber(currentValue(location, source), 1).length > 3,
            }"
            v-if="
              (currentLocation === location ||
                settings.marker.score === true ||
                ($route.name === 'location' && location.internal_id === $route.params.location)) &&
                currentSettings.with_marker_value
            "
          >
            {{ currentValue(location, source) >= 1 ? scientificNumber(currentValue(location, source), 1) : '-' }}
          </div>
          <marker-map
            class="markers__marker__content__img"
            :filters="filters"
            :current-value="currentValue(location, source)"
            :is-competitor="!location.brand_status"
          />
        </div>
      </gmap-custom-marker>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import MarkerMap from '@/components/Marker/Map.vue'
import MarkerAcronym from '@/components/Marker/Acronym.vue'
import { getValueBySource, isInActiveFilters } from '@/utils/extractor.util'
import { scientificNumber } from '@/utils/formatters.util'
import { launchGAEvent } from '@/utils/gtm.util'

export default {
  name: 'Markers',
  components: {
    GmapCustomMarker,
    MarkerMap,
    MarkerAcronym,
  },
  props: {
    map: {
      type: Object,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    activeFilters: {
      type: Array,
      required: true,
    },
    currentSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentValue: getValueBySource,
      scientificNumber,
    }
  },
  mounted() {
    this.$emit('setZoomDefault', this.map.zoom)
  },
  computed: {
    ...mapState({
      currentLocation: state => state.data.currentLocation,
      settings: state => state.radar.settings,
    }),
    ...mapGetters({
      activeSetting: 'data/activeSetting',
    }),
  },
  methods: {
    ...mapActions({
      setCurrentLocation: 'data/setCurrentLocation',
      toggleSearch: 'radar/toggleSearch',
      toggleCompare: 'radar/toggleCompare',
    }),
    toggleElements(location) {
      launchGAEvent(this.$route.params.id, `${this.$route.name}_details`, location.name)
      this.toggleSearch(false)
      this.toggleCompare(false)
      this.setCurrentLocation(location)
    },
    isVisible(location) {
      return isInActiveFilters(this.currentValue(location, this.source), this.activeFilters, this.filters)
    },
  },
  beforeDestroy() {
    this.setCurrentLocation(null)
  },
}
</script>

<style lang="scss" scoped>
.markers {
  &__marker {
    cursor: pointer;

    &__content {
      display: flex;
      position: relative;
      transform-style: preserve-3d;
      transition: transform $transition-duration-fast $transition-effect-default;
      width: 24px;

      &--tiny {
        transform: scale(0.5) translateY(10px);
      }

      &--hightlight {
        transform: scale(2) translateY(-5px);
      }

      &__koth {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -18px);
        transition: transform $transition-duration-fast $transition-effect-default;
        width: 100%;

        &--translate {
          transform: translate(-50%, -34px);
        }
      }

      &__acronym {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -12px);
      }

      &__score {
        position: absolute;
        top: 4px;
        left: 50%;
        transform: translateX(-50%);
        color: $generic-color-text-alt;
        font-family: $font-family-default;
        font-size: 0.625rem;
        font-weight: 800;

        &--md {
          top: 6px;
          font-size: 0.5rem;
        }
      }

      &__img {
        display: inline-flex;
      }
    }
  }
}
</style>
